// saturation — saturation bump (+18%). Pull each channel away from luma,
// the standard Rec. 601 luma → chroma decomposition.
//
// Bumped 1.08 → 1.18 after PMF feedback: "film-saturated" reads better at this
// level once warmCast + contrast are also stronger. Still under "vapor".

import { type FilterContext, eachPixel, getImageData, luma, putImageData } from './_helpers'

// F-wave β: 1.18 → 1.32 for the "super saturated" Polaroid feel — combined
// with coolCast + contrast 1.32 the night photos read as film, not phone tint.
const FACTOR = 1.32

export function saturation(c: FilterContext): void {
  const img = getImageData(c.ctx)
  eachPixel(img, (r, g, b, a) => {
    const l = luma(r, g, b)
    return [l + (r - l) * FACTOR, l + (g - l) * FACTOR, l + (b - l) * FACTOR, a]
  })
  putImageData(c.ctx, img)
}
